import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { HttpService } from "@services/utils/http.service";
import {
    ISystemLogModel,
    SystemLogType
} from "@models";

@Component({
    selector: "system-logs",
    templateUrl: "./system-logs.component.html"
})
export class SystemLogsComponent implements OnChanges {
    @Input() noteType: SystemLogType;
    @Input() referenceId: number;

    @Input() compact = false;
    @Input() limit?: number;
    @Input() locationsSetup = false;
    @Input() reloadKey: any;

    logs: ISystemLogModel[];

    constructor(private readonly httpService: HttpService) { }

    async ngOnChanges(changes: SimpleChanges) {
        if (changes.referenceId || changes.locationsSetup || changes.reloadKey) {
            await this.reloadLogs();
        }
    }

    async reloadLogs() {
        if (this.locationsSetup) {
            this.logs = await this.httpService.get("/systemLogs/getSystemLogsForLocationsSetup");
            return;
        }

        if (!this.referenceId) {
            this.logs = [];
            return;
        }

        const params = {
            noteType: this.noteType,
            referenceId: this.referenceId
        };

        this.logs = await this.httpService.get(
            "/systemLogs/getSystemLogs",
            params
        );
    }

    get displayedLogs(): ISystemLogModel[] {
        if (!this.logs) {
            return [];
        }

        if (!this.limit) {
            return this.logs;
        }

        return this.logs.slice(0, this.limit);
    }
}